export class StepRun {
    constructor(providerName, invocation, elapsedTime, startTime, endTime, inputs, modelParams, outputs, context, error) {
        this.providerName = providerName;
        this.invocation = invocation;
        this.elapsedTime = elapsedTime;
        this.startTime = startTime;
        this.endTime = endTime;
        this.inputs = inputs;
        this.modelParams = modelParams;
        this.outputs = outputs;
        this.context = context;
        this.error = error;
    }
}
